// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"2118b4b6","290":"1b797af9","686":"543d30fd","719":"76057063"}[chunkId] + ".chunk.js";
};